import React from 'react';
import FeaturedEventCard from './FeaturedEventCard';
import UpcomingList from './UpcomingList';

const ChapterEventList = ({ featured, events }) => {
    return (
        <>
            {featured && (
                <div style={{ marginBottom: events.length > 0 ? '16px' : 0 }}>
                    <FeaturedEventCard
                        event={featured}
                        actionUrl={featured.event_url}
                    />
                </div>
            )}
            {events.length > 0 && (
                <UpcomingList events={events} />
            )}
        </>
    );
};

export default ChapterEventList;
